import type { MarisaAuto } from '~/@types/MarisaAuto/form';
import { formatMoney } from '.';

const getMethodName = (type: string): PaymentMethods => {
  if (type === 'Debito') return 'account-debit';
  if (type === 'Boleto') return 'bank-slip';

  return 'credit-card';
};

export const getPaymentMethods = (
  selectedInsuranceQuote: MarisaAuto.InsuranceQuote
): Checkout.PaymentMethod[] => {
  const paymentMethods: Checkout.PaymentMethod[] = [];

  const installmentMapper = (
    methodName: string,
    installment: MarisaAuto.Instalment
  ): Checkout.Installment => {
    const formattedInstallment = Number(installment.numero);

    const description =
      installment.numero === '1'
        ? 'PAGAMENTO ÚNICO'
        : `ENTRADA + ${
            formattedInstallment - 1
          } PARCELAS NO ${methodName.toUpperCase()}`;

    return {
      id: formattedInstallment,
      description,
      price: Number(installment.valor),
      totalPrice: `${formatMoney(installment.valorTotal, true)}/ano`,
    };
  };

  selectedInsuranceQuote.formaPagamento.map((payment) =>
    paymentMethods.push({
      method: getMethodName(payment.tipo),
      description: payment.descricao,
      classType: parseInt(payment.tipoClasse, 10),
      code: payment.codigo,
      installments: payment.parcelas
        .map((installment) => installmentMapper(payment.descricao, installment))
        .reverse(),
    })
  );

  return paymentMethods;
};
